import React, {useEffect, useState} from 'react';
import {FormControl, FormGroup} from 'react-bootstrap';
import {getFonts} from '../../../../api/cp';

const STANDART_FONT = 'default';

const CPSettingFont = ({font = '', fonts = null, onChange}) => {
    const [fontsList, setFontsList] = useState([]);

    useEffect(getFontsList, []);

    async function getFontsList() {
        if (!fonts) {
            const data = await getFonts();
    
            setFontsList(data || []);
        } else {
            setFontsList(fonts);
        }
    }

    return (
        <FormGroup>
            <FormControl
                value={font || STANDART_FONT}
                componentClass="select"
                name="font"
                onChange={(e) => onChange({font: e.target.value})}
            >
                <option value="">Выбрать шрифт</option>
                {
                    !!fontsList.length && fontsList.map((font) => (
                        <option
                            key={font.id}
                            value={font.name}
                        >
                            {font.name}
                        </option>
                    ))
                }
            </FormControl>
        </FormGroup>
    )
};

export default CPSettingFont;
